class AssetPortfolio {
  constructor(assets) {
    this.assets = assets;
  }

  addAssets(asset) {
    this.assets.push(asset);
  }

  setAssets(assets) {
    this.assets = [];
    assets.forEach(asset => this.assets.push(asset));
  }

  calculateTotalAssets() {
    let total = 0;
    this.assets.forEach(asset => {
      total += asset.balance;
    });

    return total;
  }

  getAssetsChartData() {
    let chartData = [];
    this.assets.map(asset => {
      let _asset = asset.getAssets();
      _asset.map(entry => {
        chartData.push({
          balance: entry.balance,
          name: entry.name,
          color: entry.color,
        });
      });
    });
    return chartData;
  }

}

module.exports = AssetPortfolio;
